// apps/client/src/components/SharablePage/ShareDailyViewsChart.tsx
import { useEffect, useRef } from 'react'
import * as echarts from 'echarts'

export interface DailyPoint {
  _id: string // YYYY-MM-DD
  count: number
}

interface ShareDailyViewsChartProps {
  series: DailyPoint[]
}

export const ShareDailyViewsChart = ({ series }: ShareDailyViewsChartProps) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    const chart = echarts.init(ref.current)
    chart.setOption({
      grid: { left: 30, right: 12, top: 10, bottom: 24 },
      xAxis: { type: 'category', data: series.map((d) => d._id), axisLabel: { fontSize: 10 } },
      yAxis: { type: 'value', axisLabel: { fontSize: 10 } },
      series: [
        {
          type: 'bar',
          data: series.map((d) => d.count),
          itemStyle: { color: 'hsl(160 70% 40%)', borderRadius: [2, 2, 0, 0] },
        },
      ],
      tooltip: { trigger: 'axis' },
    })
    const onResize = () => chart.resize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
      chart.dispose()
    }
  }, [series])

  return <div ref={ref} className="w-full h-[160px]" />
}
